import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";

import Table from "./Table";
import pages from "../../../../constants/pages";
import { useAxios, useComponent } from "../../../../hooks";
import { Loader, PageHeader } from "../../../../components";

export default function IntentList({ pageID }) {
  const axios = useAxios({ baseURL: "botBuilder" });
  const { loader, pagePermissions } = useComponent({ pageID });
  const { activeBot } = useSelector((state) => state.memberDetails);

  const [intents, setIntents] = useState([]);

  useEffect(() => {
    loader.start(1);
    axios({
      url: "/get-intent/" + activeBot.ID,
      method: "GET",
    }).then((response) => {
      if (response.status) {
        setIntents(response.data);
        loader.stop();
      }
    });
  }, [axios, loader, activeBot.ID]);

  return (
    <Loader>
      <PageHeader
        pageName={"Intent List"}
        addIcon={[
          "Add Intent",
          pages.botIntentCreate.route,
          pagePermissions.create,
        ]}
      />
      <Table intents={intents} />
    </Loader>
  );
}
